// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__32WWy","icon":"SortAdornment_icon__1dBjX","up":"SortAdornment_up__UFBZ8","down":"SortAdornment_down__1EpQj","active":"SortAdornment_active__2qF1X"};